import { CommonModule } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-info-button',
  imports: [CommonModule, ButtonModule, NgClass],
  templateUrl: './info-button.component.html',
  styleUrls: ['./info-button.component.scss'],
})
export class InfoButtonComponent {
  @Input() customClass = '';
  @Input() icon = 'pi pi-question-circle';
  @Input() dialogContent = '';

  @HostListener('window:resize')
  onResize() {
    this.closePopover();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(_: MouseEvent) {
    this.closePopover();
  }

  isPopoverVisible = false;
  popoverStyle: { [key: string]: string } = {};

  togglePopover(event: MouseEvent) {
    event.stopPropagation();
    if (this.isPopoverVisible) {
      this.closePopover();
      return;
    }
    this.openPopoverAt(event);
  }

  openPopoverAt(event: MouseEvent) {
    const target = (event.currentTarget || event.target) as HTMLElement;
    if (!target) {
      this.isPopoverVisible = true;
      return;
    }
    const rect = target.getBoundingClientRect();

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const gutter = 8;
    const maxPreferredWidth = 320;
    const maxWidth = Math.min(maxPreferredWidth, vw - gutter * 2);

    const style: { [k: string]: string } = {
      position: 'fixed',
      bottom: `${Math.round(vh - rect.top + gutter)}px`, 
      'z-index': '1000',
      'max-width': `${maxWidth}px`,
      width: 'max-content',
    };

    if (vw <= 480) {
      style['left'] = `${gutter}px`;
      style['right'] = `${gutter}px`;
      style['width'] = `calc(100% - ${gutter * 2}px)`;
    } else {
      let left = rect.left;
      if (left + maxWidth > vw - gutter) {
        left = Math.max(gutter, vw - maxWidth - gutter);
      }
      style['left'] = `${Math.round(left)}px`;
    }

    this.popoverStyle = style;
    this.isPopoverVisible = true;
  }

  closePopover() {
    this.isPopoverVisible = false;
  }
}
